import { useContext, useState } from "react";
import { Form } from "react-bootstrap";
import "./User_Login.css";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import Cookies from "js-cookie";
import { AuthLogin } from "../../features/auth/Slice";
import { Context } from "../../utils/context";
import { jwtDecode } from "jwt-decode";
import { useForm } from "react-hook-form";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import classNames from "classnames";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import HotelRegistration from "../registration_forms/hotelRegistration/HotelRegistration";
import ForgetPasswordEmail from "../../common/model/ForgetPassword_Email/ForgetPasswordEmail";

const User_Login = () => {
  const dispatch = useDispatch();

  const {
    register,
    handleSubmit,
    formState: { errors },
    setError,
  } = useForm({});

  const [selectedPartner, setSelectedPartner] = useState(null);

  console.log(selectedPartner, "selectedPartner");

  const navigate = useNavigate();
  const [success, setSuccess] = useState(false);
  const [err, setErr] = useState(false);
  const [message, setMessage] = useState("");
  const { setSignin, getuserData } = useContext(Context);
  const [showPassword, setShowPassword] = useState(false);

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const [showEmailModal, setShowEmailModal] = useState(false);

  const onSubmit = async (data) => {
    try {
      const payload = {
        ...data,
        role: selectedPartner,
      };

      const res = await dispatch(AuthLogin(payload)).unwrap();

      const token = res.data.token;
      Cookies.set("af_mobility_security", token, { expires: 365 });

      setSignin(true);
      await getuserData();

      const DASHBOARD_ROUTE = {
        student: "/portal/student/dashboard",
        college: "/portal/college/college-dashboard",
        hotel: "/portal/hotel/hotel-dashboard",
        admin: "/portal/admin/admin-dashboard",
      };

      navigate(DASHBOARD_ROUTE[selectedPartner]);
    } catch (error) {
      const backendMessage = error?.errors || error?.message || "Login failed";

      if (backendMessage === "Incorrect password.") {
        setError("password", {
          type: "manual",
          message: backendMessage,
        });
      } else if (backendMessage === "Credentials does not match.") {
        setError("email", {
          type: "manual",
          message: backendMessage,
        });
      } else {
        setError("email", {
          type: "manual",
          message: backendMessage,
        });
      }
    }
  };

  const handleLogin = (e) => {
    e.preventDefault();

    if (!selectedPartner) return;

    const DASHBOARD_ROUTE = {
      student: "/dashboard",
      college: "/college-dashboard",
      hotel: "/hotel-dashboard",
      admin: "/admin-dashboard",
    };

    navigate(`/portal/${selectedPartner}${DASHBOARD_ROUTE[selectedPartner]}`);
  };

  return (
    <>
      <section className="login_wrapper">
        <div className={`login_div ${selectedPartner ? "login_mode" : ""}`}>
          <div className="row justify-content-center">
            <div className="col-lg-6 col-md-11 order-2 order-lg-1">
              <div className="left_content">
                <h1 className="main_heading">
                  From recruitment to contracts All in One Place
                </h1>

                <p className="main_text">
                  Seamlessly apply, hire, & manage every step of the internship
                  process with confidence.
                </p>

                <div className="feature_box">
                  <h5 className="feature_heading">SEAMLESS PROCESS</h5>
                  <p className="feature_text">
                    Submit your documents online, get them reviewed, and receive
                    approvals faster
                  </p>
                </div>

                <div className="feature_box">
                  <h5 className="feature_heading">ALL IN ONE</h5>
                  <p className="feature_text">
                    Apply for internships, post offers, upload CDD documents,
                    and track your applications
                  </p>
                </div>

                <div className="feature_box">
                  <h5 className="feature_heading">TRANSPARENT & RELIABLE</h5>
                  <p className="feature_text">
                    Every step is verified by experts available 24/7 to guide
                    you
                  </p>
                </div>

                <h2 className="tagline">We Nurture Talent Across The Globe</h2>
              </div>
            </div>

            <div className="col-lg-6 col-md-11 order-1 order-lg-2">
              <div className="login_card">
                <Link to="/">
                  <div className="logo_box mb-4">
                    <img
                      src="/assets/images/login-page/login-logo.png"
                      alt="logo"
                      className="login_img"
                    />
                  </div>
                </Link>

                <h3 className="welcome_title">Welcome Back!</h3>
                <p className="choose_text">
                  Select your partner type to access the portal
                </p>

                <p className="welcome_title">{selectedPartner}</p>

                {!selectedPartner && (
                  <div className="card_group">
                    <div className="row">
                      <div className="col-lg-3 col-md-3 mb-3">
                        <div
                          className="portal_card"
                          onClick={() => setSelectedPartner("student")}
                        >
                          <div className="card_img_holder">
                            <img
                              src="/assets/images/login-page/student.png"
                              className="card_img"
                              alt="student"
                            />
                            <div className="hover_overlay">
                              <div className="icon_circle">
                                <i className="fa-solid fa-angle-right"></i>
                              </div>
                            </div>
                            <div className="portal_title_box">
                              <p className="portal_title_text">Students</p>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="col-lg-3 col-md-3 mb-3">
                        <div
                          className="portal_card"
                          onClick={() => setSelectedPartner("college")}
                        >
                          <div className="card_img_holder">
                            <img
                              src="/assets/images/login-page/college.png"
                              className="card_img"
                              alt="college"
                            />
                            <div className="hover_overlay">
                              <div className="icon_circle">
                                <i className="fa-solid fa-angle-right"></i>
                              </div>
                            </div>
                            <div className="portal_title_box">
                              <p className="portal_title_text">College</p>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="col-lg-3 col-md-3 mb-3">
                        <div
                          className="portal_card"
                          onClick={() => setSelectedPartner("hotel")}
                        >
                          <div className="card_img_holder">
                            <img
                              src="/assets/images/login-page/hotel.png"
                              className="card_img"
                              alt="hotel"
                            />
                            <div className="hover_overlay">
                              <div className="icon_circle">
                                <i className="fa-solid fa-angle-right"></i>
                              </div>
                            </div>
                            <div className="portal_title_box">
                              <p className="portal_title_text">Hotel</p>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="col-lg-3 col-md-3 mb-3">
                        <div
                          className="portal_card"
                          onClick={() => setSelectedPartner("admin")}
                        >
                          <div className="card_img_holder">
                            <img
                              src="/assets/images/login-page/hotel.png"
                              className="card_img"
                              alt="hotel"
                            />
                            <div className="hover_overlay">
                              <div className="icon_circle">
                                <i className="fa-solid fa-angle-right"></i>
                              </div>
                            </div>
                            <div className="portal_title_box">
                              <p className="portal_title_text">Admin</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}

                {selectedPartner && (
                  <>
                    <button
                      className="back_btn"
                      onClick={() => setSelectedPartner(null)}
                    >
                      <i className="fa-solid fa-arrow-left"></i> Back
                    </button>

                    <div className="login_form_div">
                      <div className="form_holder">
                        <Form onSubmit={handleSubmit(onSubmit)}>
                          <Form.Group className="mb-4">
                            <Form.Label>Email</Form.Label>
                            <Form.Control
                              type="email"
                              placeholder="Enter Email"
                              className={classNames("", {
                                "is-invalid": errors?.email,
                              })}
                              {...register("email", {
                                required: "Email is required",
                              })}
                            />
                            {errors?.email && (
                              <Form.Text className="text-danger">
                                {errors?.email?.message}
                              </Form.Text>
                            )}
                          </Form.Group>

                          <Form.Group className="mb-4">
                            <Form.Label>Password</Form.Label>
                            <div
                              className="password-input-container"
                              style={{ position: "relative" }}
                            >
                              <Form.Control
                                type={showPassword ? "text" : "password"}
                                placeholder="Enter Password"
                                className={classNames("", {
                                  "is-invalid": errors?.password,
                                })}
                                {...register("password", {
                                  required: "Password is required",
                                })}
                              />
                              <FontAwesomeIcon
                                icon={showPassword ? faEye : faEyeSlash}
                                className="formPasswordIcon"
                                onClick={togglePasswordVisibility}
                                style={{
                                  position: "absolute",
                                  right: "10px",
                                  top: "50%",
                                  transform: "translateY(-50%)",
                                  cursor: "pointer",
                                  color: "#000",
                                }}
                              />
                            </div>
                            {errors?.password && (
                              <Form.Text className="text-danger">
                                {errors?.password?.message}
                              </Form.Text>
                            )}
                          </Form.Group>

                          {selectedPartner == "admin" ? (
                            ""
                          ) : (
                            <div className="login_row">
                              <p
                                className="forgot_password"
                                onClick={() => {
                                  setShowEmailModal(true);
                                }}
                              >
                                Forgot Password?
                              </p>
                            </div>
                          )}

                          <button type="submit" className="login_btn_submit">
                            Login
                          </button>

                          {selectedPartner == "admin" ? (
                            ""
                          ) : selectedPartner == "college" ? (
                            <div className="registerhere">
                              <Link
                                to="/college-register"
                                // to="/hotel-registration-form"
                                state={{ partner: selectedPartner }}
                              >
                                Register Here...
                              </Link>
                            </div>
                          ) : selectedPartner == "student" ? (
                            <div className="registerhere">
                              <Link
                                to="/user-register"
                                // to="/hotel-registration-form"
                                state={{ partner: selectedPartner }}
                              >
                                Register Here...
                              </Link>
                            </div>
                          ) : (
                            <div className="registerhere">
                              <Link
                                to="/hotel-register"
                                // to="/hotel-registration-form"
                                state={{ partner: selectedPartner }}
                              >
                                Register Here...
                              </Link>
                            </div>
                          )}
                        </Form>
                      </div>
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </section>
      <ForgetPasswordEmail
        show={showEmailModal}
        onHide={() => setShowEmailModal(false)}
        setShow={setShowEmailModal}
        selectedPartner={selectedPartner}
      />
    </>
  );
};

export default User_Login;
